const eventItemColors = {
  gray: {
    mainColor: '#67718B',
    backgroundColor: '#EBECEF',
  },
  purple: {
    mainColor: '#8F49DE',
    backgroundColor: '#F4EDFC',
  },
  blue: {
    mainColor: '#1C74DA',
    backgroundColor: '#DEEAFC',
  },
  green: {
    mainColor: '#429677',
    backgroundColor: '#E7F2EE',
  },
  red: {
    mainColor: '#F64A33',
    backgroundColor: '#FEE8E5',
  },
}

export default eventItemColors